import React, { useState, useEffect, useRef } from 'react';
import SettingIcon from "assets/fix_assets/setting_icon.svg";
import Styles from "css/normal_css/normal_m.module.css"
import AddPictureIcon from "assets/fix_assets/add_picture_button.svg"
import ImageSlider from 'components/community/image_slider';
import AddImageSlider from 'components/fix_request/add_image_slider';
import InformationIcon from 'assets/fix_assets/information_icon.svg';
import WriteAddImageSlider from 'components/community/write/write_add_image_slider_m';
import ConfirmDialog from 'components/confirm_dialog';
import OnlyConfirmDialog from 'components/onlyConfirm_dialog';
import { createCommunityPost } from 'firebase_/firebase_function/firebase_community';
import { createMatchingRequest, editMatch, getMatchingOne } from 'firebase_/firebase_function/matching';
import { useNavigate, useParams } from 'react-router-dom';
import { useFixRequest } from 'util/context/fix_request_context';
import { useUser } from 'util/context/user_context';
import OnlyLoadingScreen from 'components/loading_screen';

export default function FixRequestEditMobile({ pressedUpdate }) {
    const { docId } = useParams();
    const navigate = useNavigate();
    const { _categoryList, _setCategoryList, _selectCategory, _setSelectCategory } = useFixRequest();
    const { userData } = useUser();

    /// ✅ 로딩
    const [loading, setLoading] = useState(false);

    /// ✅ 확인모달 관련
    const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    /// ✅ 글쓰기 요소
    const [images, setImages] = useState([]); // 추가한 이미지
    const [body, setBody] = useState(""); // 내용

    useEffect(() => {
        if (docId) {
            fetchMatchData();
        }
    }, [docId])

    /// ✅ 매치 데이터 받아와서 화면에 세팅
    const fetchMatchData = async () => {
        const response = await getMatchingOne(docId);

        if (response) {
            setBody(response.etc);
            setImages(response.imageUrls);
        }
    }

    /// ✅ 매치 수정
    const handleEditPost = async () => {

        setLoading(true);

        /// file만 추출
        const imageFiles = images.map((imageData) => typeof imageData === "string" ? imageData : imageData.file[0]); // file ?? firebaseUrl

        const categoryList = Object.values(_selectCategory).map((category) => category.index !== -1 ? category.index : 0);
        const categoryName = Object.values(_selectCategory).map((category) => category.name ?? "");

        const result = await editMatch(docId, categoryList, categoryName, body, imageFiles);

        if (result) {
            await pressedUpdate();
            navigate(`/matching/${docId}`);
        } else {
            setOnlyConfirmModal(true);
            setModalMessage("요청 수정에 실패했습니다.")
        }

        setLoading(false);
    }

    return (
        <div style={{ backgroundColor: "#00000000" }}>
            {/* 기타내용 입력 */}
            <div style={{ padding: '40px 16px', display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div className='f14_374151_W500'>
                        기타내용
                    </div>
                    <div className='f14_6B7280_W400' >
                        {`(${body.length}/300)`}
                    </div>
                </div>
                <div style={{ height: "8px" }} />
                <textarea
                    value={body}
                    onChange={(e) => {
                        const input = e.target.value
                        if (input.length > 300) {
                            setOnlyConfirmModal(true);
                            setModalMessage("300글자를 넘으실 수 없습니다.")
                        } else {
                            setBody(e.target.value)
                        }
                    }}
                    className={Styles.custom_textarea}
                    style={{
                        height: '128px',
                        borderRadius: "8px",
                        border: "1px solid #D1D5DB",
                        backgroundColor: "#ffffff",
                        padding: '12px',
                        resize: "none"
                    }}
                    placeholder='문제에 대해 설명해주세요.
(예: 언제부터 시작되었는지, 어떤문제가 있는지,
특이한 소리나 현상이 있는지 등)
                    '
                />
                {/* 사진 첨부 */}
                <div style={{ height: "24px" }} />
                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between" }}>
                    <div className='f14_374151_W500'>사진 첨부</div>
                    <div className='f14_6B7280_W400'>(최대 5장)</div>
                </div>
                <div style={{ height: "8px" }} />
                {/* 사진첨부 슬라이더 */}
                <WriteAddImageSlider images={images} setImages={setImages} />

                <div style={{ height: "20px" }} />
                {/* 제안 문구 */}
                <div style={{ display: "flex", flexDirection: "row", alignItems: "start" }}>
                    <img src={InformationIcon} />
                    <div style={{ width: "4px" }} />
                    <div className='f14_6B7280_W400'>사진 첨부시 수리 견적가 온팜을 더 정확하게 파악할 수 있습니다.</div>
                </div>

            </div>
            {/* BottomFooter */}
            <div style={{ display: 'flex', flexDirection: "row", padding: "16px", gap: "16px", borderTop: "1px solid #E5E7EB", backgroundColor: "#ffffff", position: "fixed", bottom: "0", width: "100%", boxSizing: "border-box" }}>
                <div
                    onClick={() => navigate(`/matching/${docId}`)}
                    className={`f16_000000_W500`}
                    style={{ flex: "1", display: 'flex', justifyContent: "center", alignItems: "center", padding: '18px', backgroundColor: "#dfdfdf", borderRadius: "8px", cursor: "pointer" }}
                >
                    취소
                </div>
                <div
                    onClick={() => {
                        setConfirmModal(true);
                    }}
                    className='f16_FFFFFF_W500' style={{ flex: "1", display: 'flex', justifyContent: "center", alignItems: "center", padding: '18px', backgroundColor: "#2E4A24", borderRadius: "8px", cursor: "pointer" }}>
                    수리 요청하기
                </div>
            </div>

            <ConfirmDialog
                open={confirmModal}
                onClose={() => setConfirmModal(false)}
                onConfirm={() => {
                    setConfirmModal(false);
                    handleEditPost()
                }}
                message={"해당요청을 수정하시겠습니까?"}
            />

            <OnlyConfirmDialog
                open={onlyConfirmModal}
                onClose={() => setOnlyConfirmModal(false)}
                message={modalMessage}
            />

            <OnlyLoadingScreen isOpen={loading} />
        </div >
    );
}